import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/Login.tsx";
import PrivateRoute from "./components/PrivateRoute.tsx";
import RequestsTable from "./components/RequestsTable.tsx";

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/counterparty/login" element={<Login />} />
        <Route element={<PrivateRoute />}>
          <Route path="/counterparty" element={<RequestsTable />} />
          <Route path="/counterparty/requests" element={<RequestsTable />} />
          <Route
            index
            element={<Navigate to="/counterparty/requests" replace />}
          />
        </Route>
        <Route path="/" element={<Navigate to="/counterparty/login" replace />} />
      </Routes>
    </Router>
  );
};

export default App;
